var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        { attrs: { id: "themes-container" } },
        [
          _vm.settingsType === "brokerage-settings"
            ? _c("override-customizations", {
                attrs: { page: "theme" },
                on: { "update-override": _vm.handleUpdateOverride },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "4", md: "12" } },
                [
                  _c("upload-logo", {
                    attrs: {
                      logo: _vm.logo,
                      "settings-type": _vm.settingsType,
                    },
                    on: { "change-logo": _vm.handleChangeLogo },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c("theme", {
                    attrs: {
                      "settings-type": _vm.settingsType,
                      saving: _vm.saving,
                      "current-theme-object": _vm.currentThemeObject,
                    },
                    on: {
                      "allow-save": _vm.handleAllowSave,
                      "finish-saving": _vm.handleFinishSaving,
                      "set-styles": _vm.loadStyles,
                      "form-change": _vm.handleFormChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c("themes-tab-loader")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }